import React, { useState, useEffect } from 'react'
import api from '../api/api.createrole'

import { toast } from 'react-toastify'
import socketIOClient from 'socket.io-client'
import baseUrl from '../config.json'

//import './style.css'
import SideBar from '../sidebar/sidebar'
import TopBar from '../topbar/topbar'
const ENDPOINT = baseUrl.apiEndPoint


function Createrole(){

    const[name,setName] = useState('')
   
    const [role, setRole] = useState([])

    useEffect(()=>{
      getRoles()
    },[])
    
    const getRoles = () =>  {
      console.log("data=>data")
      api.getrole().then(res => {
        console.log("data=>",res.data)
       setRole(res.data)
      })
      }

    return(
      
        <div class='wrapper'> 
        <SideBar />
        <div class='main-panel'>
        <TopBar />
        <div class='content'>
          <div class='container-fluid'>
            <div class='row'>
              <div class='col-lg-12 col-md-12'>
                <div class='card'>

                <div class='header'>
                    <h5 class='title'>Create Role</h5>
                  </div>
                  <div class='content' style={{ padding: '10px' }}>
                  <card class='table table-striped'>
                  <thead>
                        <tr>
                          <th>Role</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                        <td>
                        <input
                              type='text'
                              class='form-control border-input'
                              disabled=''
                              placeholder='Role'
                              value={name}
                              onChange={e => {
                                setName(e.target.value)
                              }}
                            ></input>   
                        </td></tr> 
                        <td>
                        <div class='form-group'>
                              <div style={{ margin: '26px 0px' }}>
                                  <button
                                  type='submit'
                                  class='btn btn-info btn-fill btn-wd'
                                  onClick={e => {
                                    e.preventDefault() 

                                    let data={
                                        name:name
                                    }
                                    api.createrole(data).then(res=>{
                                      getRoles()
                                        toast("New role created sucessfully")
                                        setName('')
                                    })
                                  }}
                                  >
                                      Save

                                  </button>
                                  </div> 
                                  </div>
                        </td>

                      </tbody>


                      </card>

                  </div>

                </div>
                </div>
                </div>
                </div>
                </div>
                    

                    
                <div class='row'>
                  <div class='col-lg-12 col-md-12' style={{'padding': '0px 14px'}}>
                    <div class='card'>
                      <div class='header'>
                        <h5 class='title'>Role Details</h5>
                      </div>
                      <div class='content table-responsive table-full-width'  >
                        {/* <card class="table table-striped"> */}

                        <table id='roles' class='table tableextra' >
                          <thead>
                            <tr>
                              <th style={{'width':'50px'}}>Sl.No</th>
                             
                              <th style={{'width':'100px'}}>Role</th>
                              
                            </tr>
                          </thead>
                          <tbody>
                            {
                              role.map((item,index)=>(
<tr>
<td>{index +1}</td>
<td>{item.name}</td>
</tr>
                              ))
                            }
                          </tbody>
                        </table>
                        {/* </card> */}
                      </div>
                    </div>
                  </div>
                </div>

        </div>
        </div>

    )
}
export default Createrole